import { Building2, Check } from "lucide-react";
const beneficios = ["White-label completo con tu marca", "Onboarding dedicado para tu equipo", "SLA y soporte prioritario", "Integraciones a medida con tus sistemas", "Capacidad y usuarios según contrato", "Cumplimiento a escala corporativa"];
export default function BloqueEnterprise() {
  return <section data-section-id="REEMPLAZAR" id="bloque-enterprise" className="bg-card text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-5xl mx-auto rounded-2xl border-2 border-amber-600/20 bg-gradient-to-br from-background to-amber-950/10 p-8 md:p-12">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-600/10 border border-amber-600/20 mb-5">
                <Building2 className="size-4 text-amber-600" />
                <span className="text-xs font-mono uppercase tracking-wider text-amber-600">
                  ¿Eres un corporativo?
                </span>
              </div>
              <h2 className="font-default text-3xl md:text-4xl font-extrabold tracking-tight text-white mb-4">
                Soluciones Enterprise a medida
              </h2>
              <p className="font-default text-base md:text-lg text-slate-400 leading-relaxed">
                Si manejas múltiples oficinas, grupos empresariales o necesitas integración profunda con tus sistemas, el plan Enterprise se adapta a tu operación. Escríbenos en el formulario de arriba con el asunto "Enterprise" y un asesor preparará una cotización para ti.
              </p>
            </div>

            <div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {beneficios.map((b, i) => <li key={i} data-index={i} className="flex items-start gap-2">
                    <Check className="size-4 text-amber-600 flex-shrink-0 mt-1" />
                    <span className="font-default text-sm text-slate-300">{b}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}